"use client";

import AppleSignin from "react-apple-signin-auth";
import { FaApple } from "react-icons/fa6";

export default function AppleOAuthButton({ onSuccess, onError }) {
  // Utility function to decode JWT without verification (client-side)
  const decodeJWT = (token) => {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join(""),
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error("Failed to decode JWT:", error);
      return null;
    }
  };

  // REAL APPLE SIGN IN (when credentials are configured)
  const handleSuccess = (response) => {
    try {
      console.log("Apple OAuth Response:", response);

      const identityToken = response.authorization?.id_token;

      if (!identityToken) {
        throw new Error("Missing identity token from Apple");
      }

      // Decode JWT to extract user information
      const decodedToken = decodeJWT(identityToken);
      console.log("Decoded Apple JWT:", decodedToken);

      if (!decodedToken || !decodedToken.sub) {
        throw new Error("Invalid identity token from Apple");
      }

      const providerId = decodedToken.sub;

      // Extract email from response.user (first login) or decoded JWT (subsequent logins)
      const email = response.user?.email || decodedToken.email || "";

      console.log("Extracted providerId:", providerId);
      console.log("Extracted email:", email);

      onSuccess({
        provider: "apple",
        clientId:
          process.env.NEXT_PUBLIC_APPLE_CLIENT_ID ||
          "service.com.app.hivora",
        providerId,
        identityToken,
        email,
        name: `${response?.user?.name?.firstName || ""} ${response?.user?.name?.lastName || ""}`.trim(),
        firstName: response?.user?.name?.firstName || "",
        lastName: response?.user?.name?.lastName || "",
      });
    } catch (error) {
      console.error("Error processing Apple response:", error);
      onError(error);
    }
  };

  const handleError = (error) => {
    console.error("Apple login failed:", error);
    onError(error);
  };

  return (
    <AppleSignin
      authOptions={{
        clientId:
          process.env.NEXT_PUBLIC_APPLE_CLIENT_ID || "service.com.app.hivora",
        scope: "email name",
        redirectURI: "https://stag.hivora.ai/",
        usePopup: true,
      }}
      onSuccess={handleSuccess}
      onError={handleError}
      render={(props) => (
        <button
          onClick={props.onClick}
          className="social-btn apple"
          type="button"
        >
          <FaApple />
        </button>
      )}
    />
  );
}
